import { formatNumber } from "@angular/common";
import * as L from "leaflet";

import { RoadworkSectionDto } from "../services/bbo-client.service";
import { Point } from "./point.model";

export const ROADWORK_SECTION_POLYLINES_PANE = "roadwork-sections";

export enum SectionType {
	Entry = "entry",
	Section = "section",
}

export class RoadworkSection {
	roadworkId: string;
	sectionId: number;
	trace: Point[];
	beginMeter: number;
	endMeter: number;
	speed: number;
	usableLanes: string;
	blockedLanes: string;

	constructor(res: RoadworkSectionDto) {
		this.roadworkId = res.roadworkId as string;
		this.beginMeter = res.beginMeter as number;
		this.endMeter = res.endMeter as number;
		this.speed = res.speed as number;
		this.usableLanes = res.usableLanes as string;
		this.blockedLanes = res.blockedLanes as string;
		this.sectionId = res.sectionId as number;
		this.trace = res.trace as Point[];
	}

	public getPolyline(weight: number, color: string): L.Polyline {
		return L.polyline(
			this.trace.map((coord) => [coord.lat, coord.lon]),
			{
				pane: ROADWORK_SECTION_POLYLINES_PANE,
				weight: weight,
				color: color,
				lineCap: "inherit",
			},
		);
	}

	public getPolylineWithGivenStart(weight: number, color: string, startPoint?: Point): L.Polyline {
		return L.polyline(
			this.trace.map((coord, index) => {
				return index == 0 ? [startPoint?.lat ?? coord.lat, startPoint?.lon ?? coord.lon] : [coord.lat, coord.lon];
			}),
			{
				pane: ROADWORK_SECTION_POLYLINES_PANE,
				weight: weight,
				color: color,
				lineCap: "inherit",
			},
		);
	}

	public getTooltipBaseInfo(segmentNumber: number): string {
		return `Segment ${segmentNumber}`;
	}

	public getTooltipDetailInfo(segmentNumber: number): string {
		return `
            <b>${this.getTooltipBaseInfo(segmentNumber)}</b>
            <div>km ${formatNumber(this.beginMeter / 1000, navigator.language, "1.0-2")} bis km ${formatNumber(this.endMeter / 1000, navigator.language, "1.0-2")}</div>
            ${this.usableLanes ? "<div>Verwendbar: " + this.usableLanes + "</div>" : ""}
            ${this.blockedLanes ? "<div>Blockiert: " + this.blockedLanes + "</div>" : ""}
            ${this.speed ? "<div>Geschwindigkeitslimit: " + this.speed + "km/h</div>" : ""}
        `;
	}
}
